import AbsEditViewValueFormatter from "@/utils/UIConstants/AGGridEditViewValueFormatters/AbsEditViewValueFormatter.ts";
import NumberUtils from "@/utils/common/NumberUtils.ts";
import {StringUtils} from "@/utils/common/StringUtils.ts";
import NamaCommon from "@/utils/common/NamaCommon.ts";

export default class BigDecimalValueFormatter extends AbsEditViewValueFormatter
{
  private static _instance: BigDecimalValueFormatter;

  static instance() {
    if (!this._instance)
      this._instance = new BigDecimalValueFormatter();
    return this._instance;
  }

  override format(specs: namaTypes.DTOFieldSpecs | null | undefined, value: any) {
    if (!value)
      return "";
    if (specs && (specs.decimalPlaces || specs.decimalPlaces === 0)) {
      if (specs.decimalPlaces >= 0)
        value = NumberUtils.roundToDecimalPlaces(value, specs.decimalPlaces);
      else
        value = NumberUtils.stripTrailingZeros(value);
    }
    if (specs && specs.format)
      return NumberUtils.formatByPattern(specs, value);
    else
      return NumberUtils.stripTrailingZeros(value);
  }

  override parse(specs: namaTypes.DTOFieldSpecs | null | undefined, valueNum: any, oldValue?: any) {
    if (!valueNum)
      return 0;
    let value = valueNum as string;
    value = StringUtils.replaceArNumerals(value)
    value = NumberUtils.removeComma(value);
    let operatorsEvaluation = NamaCommon.parseOperators(value);
    if (operatorsEvaluation)
      return operatorsEvaluation;
    if (specs)
      return NumberUtils.parseFromPattern(specs, value) ?? 0;
    if (isNaN(Number(value)))
      return oldValue || 0;
    return value;
  }
}
